import { render } from "./BehaviorCluster.vue?vue&type=template&id=cec41014"
import script from "./BehaviorCluster.vue?vue&type=script&lang=js"
export * from "./BehaviorCluster.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__